import { AdditionalRequestOptions } from '../../services';
import { handleRequest } from '../../utils';

import { getUserCouponsReqObj } from '../config';
import { Search } from '../models';
import { UserCouponPayload } from './types/types';

export const couponSearchApi = {
  getUserCoupons(payload?: UserCouponPayload, options?: AdditionalRequestOptions): Promise<Search> {
    const req = getUserCouponsReqObj();
    req.params = payload;
    return handleRequest(req, options);
  },
};

export default couponSearchApi;
